import { render, staticRenderFns } from "./DeepLTranslationsProject.vue?vue&type=template&id=fe14422e&"
import script from "./DeepLTranslationsProject.vue?vue&type=script&lang=js&"
export * from "./DeepLTranslationsProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports